import React from "react";
import { motion } from "framer-motion";
import Section from "./Section";
import {
  Network,
  Sparkles,
  Languages,
  Cloud,
  ShieldCheck,
  Activity,
  Wifi,
  Building2,
} from "lucide-react";

const items = [
  { icon: Network, t: "One connected platform", d: "Guests, staff, management — always in sync." },
  { icon: Sparkles, t: "Guest-first experience", d: "Every interaction feels five-star." },
  { icon: Languages, t: "Multilingual", d: "13+ languages, out of the box." },
  { icon: Cloud, t: "Cloud platform", d: "Zero on-prem overhead. Deployed in days." },
  { icon: ShieldCheck, t: "Enterprise security", d: "ISO 27001, PII-aware by design." },
  { icon: Activity, t: "Operational visibility", d: "Live SLA, live staff, live signals." },
  { icon: Wifi, t: "Real-time communication", d: "Requests move at the speed of your team." },
  { icon: Building2, t: "Built for modern hotels", d: "From boutique to chain to hospital group." },
];

export default function WhyInplass() {
  return (
    <Section
      overline="Why iNPLASS"
      testId="why-inplass-section"
    >
      <h2
        className="font-display text-white text-[36px] md:text-[52px] leading-[1.02] tracking-tight max-w-4xl"
        style={{ fontWeight: 800 }}
      >
        Purpose-built for the properties that{" "}
        <span className="grad-text">define modern hospitality.</span>
      </h2>

      <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4">
        {items.map((it, i) => (
          <motion.div
            key={it.t}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45, delay: i * 0.04 }}
            className="rounded-xl brand-panel p-6 hover:-translate-y-1 hover:border-brand-purpleLight/60 transition-transform duration-300"
            data-testid={`why-item-${it.t.toLowerCase().replace(/\s/g, "-")}`}
          >
            <div className="w-10 h-10 rounded-lg bg-white/15 grid place-items-center text-white">
              <it.icon size={18} />
            </div>
            <div
              className="mt-5 font-display text-white text-[19px] leading-tight"
              style={{ fontWeight: 700 }}
            >
              {it.t}
            </div>
            <div className="mt-1.5 text-white/70 text-[13px]">{it.d}</div>
          </motion.div>
        ))}
      </div>
    </Section>
  );
}
